// extracted by mini-css-extract-plugin
export default {"lottery-table__name":"LotteryTable_lottery-table__name__jGk1U","lottery-table-row":"LotteryTable_lottery-table-row__7Lq8R"};